module.exports = __webpack_public_path__ + "static/media/lemon.d45cfcf8.svg";